(function () {
    'use strict';

    angular.module("imApp").factory("consignmentOlService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 328,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
